import React from "react";
import type { DocumentElement as DocumentElementType } from "@eaco/forms-core";

import HiddenElementBanner from "./HiddenElementBanner";
import ArchivedElementBanner from "./ArchivedElementBanner";

interface Props {
  element: DocumentElementType;
}

const Paragraph: React.FC<Props> = ({ element }) => {
  const data = element.data as {
    text?: string;
    hidden?: boolean;
  };
  const text = data?.text || "Enter your paragraph text here...";

  return (
    <div className="space-y-1">
      <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
        {text}
      </p>
      <HiddenElementBanner hidden={data?.hidden} />
      <ArchivedElementBanner archived={element.archived} />
    </div>
  );
};

export default Paragraph;
